'use client'

import type { NavGroup } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { AppVariant } from '@common/enums'

import { BaseMobileMenu } from '../../BaseMobileMenu'

import { AcademyNavigation } from './components/AcademyNavigation'
import { useMobileNavigation } from './hooks/useMobileNavigation'
import type { AcademyMobileMenuProps } from './types'

const EMPTY_MENU_GROUPS: NavGroup[] = []

export function AcademyMobileMenu({
  isOpen,
  onClose,
  onNavigationClick,
  tutorialSections = [],
  currentTutorialPath,
  categoryTree,
  rootArticles,
}: AcademyMobileMenuProps) {
  const nav = useMobileNavigation({
    tutorialSections,
    categoryTree,
    rootArticles,
    onNavigationClick,
    onClose,
  })

  return (
    <div data-testid={MOBILE_MENU_TEST_IDS.academyMenu} style={{ display: 'contents' }}>
      <BaseMobileMenu
        isOpen={isOpen}
        onClose={onClose}
        appVariant={AppVariant.ACADEMY}
        menuGroups={EMPTY_MENU_GROUPS}
        onNavigationClick={onNavigationClick}
        showProjectSelector={false}
        showWorkspaceSelector={false}
        navigationTopSlot={
          <AcademyNavigation nav={nav} tutorialSections={tutorialSections} currentTutorialPath={currentTutorialPath} />
        }
      />
    </div>
  )
}
